<template>
  
  <v-tooltip 
    bottom
    open-delay    = "500"
    :disabled     = "!tooltip"
  >

    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class     = "toolbar-button px-0"
        height    = "100%"
        min-width = "48px"
        tile
        elevation = "0"
        v-bind    = "attrs"
        v-on      = "on"
        :disabled = "disabled"
        :color    = "color ? color : 'transparent'"
        @click    = "$emit('click', $event);"
      >
        <slot></slot>
      </v-btn>
    </template>

    <span>
      <span>{{ tooltip }}</span>
      <span 
        v-if  = "hotkey"
        class = "hotkey"
      >{{ hotkey }}</span>
    </span>

  </v-tooltip>

</template>

<script>

export default {

  // #region Properties

  name:  'ToolbarButton',
  props: {
    disabled: Boolean,
    color:    String,
    tooltip:  String,
    hotkey:   String
  }

  // #endregion Properties

}

</script>

<style lang="scss" scoped>
  $hotkey_color: rgba(255, 255, 255, 0.6);

  .toolbar-button.v-btn--disabled.v-btn--has-bg {
    background-color: transparent !important;
  }

  .hotkey {
    text-align:     center;
    margin-left:    16px;
    color:          $hotkey_color;
    border:         1px solid $hotkey_color;
    border-radius:  4px;
    padding:        2px 6px;
  }

</style>